import React from 'react';
import { BrandingOption, HelpButton, HelpButtonAction } from '../../stores/BrowserBarOptions';
import { Field, FTBody } from '../Fuse';

export const BrandingOptionField = (props) => <Field
    label="Branding Option"
    tooltip="Allows you to provide your own branding text
                 or use the default Proofpoint branding to be displayed in the browser bar. "
    {...props}
/>;

export const BrandingOptionView = {
    [BrandingOption.DEFAULT]: <FTBody><strong>Default</strong> - use Proofpoint branding.</FTBody>,
    [BrandingOption.CUSTOM]: <FTBody><strong>Custom</strong> - specify your own branding.</FTBody>,
};

export const HelpButtonField = (props) => <Field
    label="Help Link Option"
    tooltip="Allows you to provide help text and/or optional external links
                 to help content that can be accessed from the browser bar."
    {...props}
/>;

export const HelpButtonView = {
    [HelpButton.DISABLED]: <FTBody><strong>No Link</strong> - do not provide a help link.</FTBody>,
    [HelpButton.ICON]: <FTBody><strong>Help Icon</strong> - provide a “?” icon as a help link.</FTBody>,
    [HelpButton.BRANDING]: <FTBody><strong>Custom Branding</strong> - use your custom branding as a help link.</FTBody>,
};

export const HelpButtonActionField = (props) => <Field
    label="Click Option"
    tooltip="Provide an external link to open in a new tab when clicked or provide help text that will be displayed
                 in a popup. Popup help text may contain external links to additional help or resources."
    {...props}
/>;

export const HelpButtonActionView = {
    [HelpButtonAction.LINK]: <FTBody><strong>External Link</strong> - opens the help link in a new tab.</FTBody>,
    [HelpButtonAction.POPUP]: <FTBody><strong>Popup Message</strong> - display a popup message when clicked.</FTBody>,
};
